export default __webpack_public_path__ + "static/media/slider_2-xs@1x.cd4cb79f.jpg";